<style scoped lang="stylus" rel="stylesheet/stylus"></style>
<template>
	<div class="tab-bar">
		<van-tabbar v-model="curPath" @change="routerChange" placeholder>
			<template v-for="(item, index) in $store.state.tabbarList">
				<van-tabbar-item :name="item.path" :icon="item.icon" :key="index">{{ item.name }}</van-tabbar-item>
			</template>
		</van-tabbar>
	</div>
</template>

<script>
export default {
	name: 'tabBar',
	watch: {
		'$route.path': {
			handler: function(newVal, oldVal) {
				// console.log(this.curPath)
				this.curPath = newVal
			},
			deep: true,
			immediate: true
		}
	},
	computed: {},
	data() {
		return {
			curPath: this.$route.path
		}
	},
	methods: {
		routerChange(e) {
			this.curPath = e
			this.$router.replace(e)
		}
	}
}
</script>
